var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { cssColorValue, Image, Text } from '@spotify-internal/encore-web/core';
import React from 'react';
import styled from 'styled-components';
import { Link } from '../../../../../LinkV2';
import { fadeInAnimation } from '../../../../fadeInAnimation';
var LinkWrapper = styled(Link).withConfig({
    shouldForwardProp: function (prop) { return !['delay'].includes(prop); }
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var delay = _a.delay;
    return delay && fadeInAnimation(delay);
});
var WithMediaWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  color: ", ";\n  .text {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    text-align: start;\n    gap: 6px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  color: ", ";\n  .text {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    text-align: start;\n    gap: 6px;\n  }\n"])), cssColorValue('textBase'));
var ImageWrapper = styled(Image)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  aspect-ratio: 21 / 9;\n  width: 100%;\n  object-fit: cover;\n"], ["\n  aspect-ratio: 21 / 9;\n  width: 100%;\n  object-fit: cover;\n"])));
export var MobileGalleryLink = function (_a) {
    var _b;
    var image = _a.image, description = _a.description, link = _a.link, trackingCategory = _a.trackingCategory, delay = _a.delay;
    var formattedLink = __assign(__assign({}, link), { trackingCategory: trackingCategory });
    return (React.createElement(LinkWrapper, __assign({}, formattedLink, { delay: delay }),
        React.createElement(WithMediaWrapper, null,
            React.createElement(ImageWrapper, { src: (_b = image === null || image === void 0 ? void 0 : image.file) === null || _b === void 0 ? void 0 : _b.url }),
            React.createElement("div", { className: "text" },
                React.createElement(Text, { variant: "titleSmall" },
                    link.label,
                    " "),
                React.createElement(Text, { variant: "bodyMedium" }, description)))));
};
var templateObject_1, templateObject_2, templateObject_3;
